// Module
var code = `<table class="table table-bordered tableNew info-table"> <thead> <tr *ngIf="this.header"> <th [attr.colSpan]="this.colSpan" class="blue-header"> <span>{{this.header}}</span> </th> </tr> </thead> <tbody> <tr *ngFor="let row of this.data"> <td *ngFor="let item of row">{{item}}</td> </tr> </tbody> </table> `;
// Exports
export default code;